import React, { useState, useEffect } from "react";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Collapse,
	Table,
} from "reactstrap";
import DeleteModal from "components/Common/DeleteModal";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AddSubToMainModal from "../AddSubToMainModal";

const CardItem = ({
	index,
	item,
	id,
	Service,
	hasSub,
	setTypeState,
	setParentId,
	pageNum,
	searchId,
	name,
	status,
	toggleModal,
	type,
	header,
	setEditObj,
	reqType,
	setAdd,
	setShouldGetData,
}) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const [itemStatus, setItemStatus] = useState(false);
	const [deletedItem, setDeletedItem] = useState(null);
	const [movedItem, setMovedItem] = useState(null);
	const [addSub, setAddSub] = useState(false);
	const service = new Service();
	const AuthData = useSelector((state) => state.Auth);
	const isExist = (data) => AuthData.permissions.includes(data);
	const toggle = () => setDropdownOpen((prevState) => !prevState);
	const [show, setShow] = useState(null);
	const handleCloseModal = (action, response) => {
		setDeleteModal(false);
		if (action === "delete") {
			setShouldGetData(true);
		}
	};

	useEffect(() => {
		setItemStatus(status);
	}, [status]);

	const changeStatusToggle = (e, changeId, setStatus) => {
		const value = e.target.checked;
		service.changeStatus(changeId, type).then((res) => {
			if (res && res.status === SuccessOk) {
				setStatus(value);
				toast.success("Status Changed Successfully");
			}
		});
	};

	const SubRow = ({ ind, child }) => {
		const [childItemStatus, setChildItemStatus] = useState(false);
		const [subDropdownOpen, setSubDropdownOpen] = useState(false);
		const subToggle = () => setSubDropdownOpen((prevState) => !prevState);

		useEffect(() => {
			setChildItemStatus(child.status);
		}, [child.status]);

		return (
			<tr style={{ borderBottom: "1px solid #dedede" }}>
				<td className="bg-light m-0">
					<p
						className="font-size-16 text-center mb-0"
						style={{ lineHeight: "3" }}>
						{searchId || (pageNum - 1) * 10 + (index + 1)}.{ind + 1}
					</p>
				</td>
				<td className="bg-light m-0">
					<span className="font-size-16" style={{ lineHeight: "3" }}>
						{child.name?.en}
					</span>
				</td>
				<td className="font-size-14 bg-light py-0">
					<form className="d-flex mt-2">
						<div className="form-check form-switch form-switch-md mb-1">
							<input
								name="status"
								checked={childItemStatus}
								type="checkbox"
								className="form-check-input"
								id="has_status"
								onChange={(e) =>
									changeStatusToggle(e, child.id, setChildItemStatus)
								}
								disabled={isExist("setting.edit") ? false : true}
							/>
						</div>
					</form>
				</td>
				<td className="bg-light ">
					<div className="removebtnhover mt-2">
						{(isExist("setting.add") ||
							isExist("setting.edit") ||
							isExist("setting.delete")) && (
							<Dropdown
								color="light"
								className="dropdownWidth"
								isOpen={subDropdownOpen}
								toggle={subToggle}>
								<DropdownToggle caret>
									<i className="fa fa-ellipsis-v text-dark fa-lg ms-2"></i>
								</DropdownToggle>
								<DropdownMenu
									className="mb-2"
									style={{ right: "auto !important" }}>
									{isExist("setting.edit") && (
										<DropdownItem
											onClick={() => {
												setTypeState("Sub");
												setAdd(false);
												setEditObj(child);
												toggleModal();
											}}>
											Edit
										</DropdownItem>
									)}
									{isExist("setting.add") && (
										<DropdownItem
											onClick={() => {
												setTypeState("Sub");
												setMovedItem(child);
												setAddSub(true);
											}}>
											Add to main Type
										</DropdownItem>
									)}
									{isExist("setting.delete") && (
										<DropdownItem
											className="text-danger"
											onClick={() => {
												setDeletedItem(child);
												setDeleteModal(!deleteModal);
											}}>
											Remove {header}
										</DropdownItem>
									)}
								</DropdownMenu>
							</Dropdown>
						)}
					</div>
				</td>
			</tr>
		);
	};
	return (
		<>
			<tr key={index}>
				<td className="font-size-16">
					{searchId || (pageNum - 1) * 10 + (index + 1)}
				</td>
				<td className="font-size-16">{name?.en}</td>
				<td className="font-size-14 py-0">
					<form>
						<div className="form-check form-switch form-switch-md mb-1">
							<input
								name="status"
								checked={itemStatus}
								type="checkbox"
								className="form-check-input"
								id="has_status"
								onChange={(e) => changeStatusToggle(e, id, setItemStatus)}
								disabled={isExist("setting.edit") ? false : true}
							/>
						</div>
					</form>
				</td>

				{isExist("setting.add") ||
				isExist("setting.edit") ||
				isExist("setting.delete") ? (
					<td
						className={`removebtnhover d-flex ${
							hasSub ? "justify-content-between" : ""
						}`}>
						<Dropdown
							color="light"
							className="dropdownWidth"
							isOpen={dropdownOpen}
							toggle={toggle}>
							<DropdownToggle caret>
								<i className="fa fa-ellipsis-v text-dark fa-lg"></i>
							</DropdownToggle>

							<DropdownMenu className="mb-2">
								{isExist("setting.edit") ? (
									<DropdownItem
										onClick={() => {
											setAdd(false);
											setEditObj(item);
											toggleModal();
										}}>
										Edit
									</DropdownItem>
								) : null}
								{hasSub && item.children == 0 && isExist("setting.add") && (
									<DropdownItem
										onClick={() => {
											setMovedItem(item);
											setTypeState("main");
											setAddSub(true);
										}}>
										Add to main Type
									</DropdownItem>
								)}
								{hasSub && isExist("setting.add") && (
									<DropdownItem
										onClick={() => {
											setTypeState("Sub");
											setAdd(true);
											setEditObj(null);
											setParentId(id);
											toggleModal();
										}}>
										Add Sub{type}
									</DropdownItem>
								)}
								{isExist("setting.delete") ? (
									<DropdownItem
										className="text-danger"
										onClick={() => {
											setDeletedItem(item);
											setDeleteModal(!deleteModal);
										}}>
										Remove {header}
									</DropdownItem>
								) : null}
							</DropdownMenu>
						</Dropdown>

						{hasSub && (
							<div className="font-size-16 ms-4">
								{item.children?.length > 0 && (
									<button
										style={{
											background: "none",
											border: "none",
											background: "#556ee6",
											color: "#fff",
											borderRadius: "50%",
											padding: "0",
										}}
										className="btn"
										onClick={() => setIsOpen(!isOpen)}>
										{isOpen ? (
											<i
												className="fa fa-chevron-up fa-lg"
												style={{ fontSize: "12px", padding: "8px 7px" }}></i>
										) : (
											<i
												className="fa fa-chevron-down fa-lg"
												style={{ padding: "10px 8px" }}></i>
										)}
									</button>
								)}
							</div>
						)}
					</td>
				) : null}
			</tr>
			{hasSub &&
				item.children?.length > 0 &&
				isOpen &&
				item.children?.map((child, index) => {
					return <SubRow ind={index} child={child} />;
				})}

			<DeleteModal
				open={deleteModal}
				titleMsg={name.en}
				deletedItem={deletedItem}
				modelService={service}
				onCloseModal={(action) => handleCloseModal(action)}
			/>

			{addSub && (
				<AddSubToMainModal
					modal={addSub}
					toggle={() => setAddSub(false)}
					Service={service}
					type={type}
					reqType={reqType}
					item={movedItem}
					setShouldGetData={setShouldGetData}
				/>
			)}
		</>
	);
};

export default CardItem;
